/**
 * created by hezq on: 2022-11-16 16:06:29
 *
 * description： 原生ajax封装
 *
 */

import util from './util.js'

// 格式化请求参数
function formatParams(data) {
	var arr = []
	for (var name in data) {
		arr.push(encodeURIComponent(name) + "=" + encodeURIComponent(data[name]))
	}
	arr.push(("_=" + Math.random()).replace(".", ""))
	return arr.join("&")
}

export default function fetch(options) {
	// 调用函数时如果options没有指定，就给它赋值{},一个空的Object
	options = options || {}
	// 请求格式GET、POST，默认为GET
	options.method = (options.method || 'GET').toUpperCase()
	// 响应数据格式，默认json
	options.dataType = options.dataType || 'json'
	// 加上基础路径
	options.url = window._behaviourOptions.server + options.url

	// options.data请求的数据
	const params = formatParams(options.data)
	let xhr
	// 考虑兼容性
	if (window.XMLHttpRequest) {
		xhr = new XMLHttpRequest()
	} else if (window.ActiveObject) {
		// 兼容IE6以下版本
		// eslint-disable-next-line no-undef
		xhr = new ActiveXobject('Microsoft.XMLHTTP')
	}
	const method = options.method
	let url = ''
	// 启动并发送一个请求
	if (method === 'GET') {
		url = options.url + '?' + params
	} else if (method === 'POST') {
		url = options.url
	}

	xhr.open(method, url, true)

	// Content-type数据请求的格式
	if (method === 'POST') {
		xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8;')
	}

	// 获取token
	const accessToken = util.getToken().accessToken
	// 判断是否存在token，如果存在的话，则每个http header都加上token
	if (accessToken) {
		xhr.setRequestHeader('Authorization', accessToken)
	}
	// appKey设置
	xhr.setRequestHeader('appKey', window._behaviourOptions.appKey || '')

	xhr.send(method === 'POST' ? JSON.stringify(options.data) : null)

	if (options.timeout) {
		// 设置有效时间
		setTimeout(() => {
			if (xhr.readySate !== 4) {
				xhr.abort()
			}
		}, options.timeout)
	}

	// 接收数据
	// options.success成功之后的回调函数  options.error失败后的回调函数    
	// xhr.responseText,xhr.responseXML  获得字符串形式的响应数据或者XML形式的响应数据        
	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			var status = xhr.status
			if (status >= 200 && status < 300 || status === 304) {
				let result = ''
				try {
					result = JSON.parse(xhr.responseText)
				} catch (e) {
					result = xhr.responseText
				}
				if (result && result.code) {
					if (result.code === 200) {
						options.success && options.success(result)
					} else {
						options.error && options.error(result)
					}
				} else {
					options.success && options.success(result)
				}
			} else {
				options.error && options.error('ajax request error')
			}
		}
	}

	xhr.onerror = function() {
		options.error && options.error(xhr.statusText)
	}
}



// WEBPACK FOOTER //
// ./src/ajax.js